import React from 'react';
import { Link } from 'react-router-dom';
import { PublicLegalShell } from '../components/layout/PublicLegalShell';

export default function TermsPage() {
  return (
    <PublicLegalShell title="Terms of use" eyebrow="Trust & legal">
      <p>
        MyLegacyBridge is provided for personal family archiving. You retain ownership of content you upload. Abuse,
        impersonation, and unlawful use are not permitted.
      </p>
      <p>
        Memorial and tribute pages are optional. Families remain responsible for what they publish and for moderating
        tributes they choose to display.
      </p>
      <p>
        Full terms will be published before general launch. If you have questions, please{' '}
        <Link to="/contact" className="text-[hsl(38_36%_42%)] underline underline-offset-2">
          contact us
        </Link>{' '}
        or read the{' '}
        <Link to="/faq#terms" className="text-[hsl(38_36%_42%)] underline underline-offset-2">
          FAQ terms summary
        </Link>
        .
      </p>
    </PublicLegalShell>
  );
}
